import { render, staticRenderFns } from "./workpackage-item.vue?vue&type=template&id=bad88f80&scoped=true"
import script from "./workpackage-item.vue?vue&type=script&lang=js"
export * from "./workpackage-item.vue?vue&type=script&lang=js"
import style0 from "./workpackage-item.vue?vue&type=style&index=0&id=bad88f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad88f80",
  null
  
)

export default component.exports